import { ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IIncidentCode, IncidentCodeService } from '@shared/services/incident-code-service';
import { map, Observable, startWith } from 'rxjs';

@Component({
	selector: 'app-create-incident-code',
	templateUrl: './create-incident-code.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CreateIncidentCodeComponent implements OnInit {
	@Output() created: EventEmitter<any> = new EventEmitter();
	incidentCode: IIncidentCode;
	form: FormGroup;
	loading: boolean = false;
	httpError: string = '';
	filteredGroups: Observable<string[]>;
	groupControl: FormControl<string>;

	constructor(
		public dialogRef: MatDialogRef<CreateIncidentCodeComponent>,
		@Inject(MAT_DIALOG_DATA)
		public dialogData: { incidentCodeGroups: string[] },
		private service: IncidentCodeService,
		private fb: FormBuilder,
	) {
		this.incidentCode = {
			id: null,
			name: null,
			group: null,
			isActive: true,
			alias: null,
		};
	}

	ngOnInit(): void {
		this.initializeForm();
		this.groupControl = this.controls['group'] as FormControl<string>;
		this.filteredGroups = this.groupControl.valueChanges.pipe(
			startWith(''),
			map((value) => {
				const filterValue = value.toLowerCase();
				return this.dialogData.incidentCodeGroups.filter((group) => group.toLowerCase().includes(filterValue));
			}),
		);
	}

	initializeForm(): void {
		this.form = this.fb.group({
			name: [this.incidentCode.name, [Validators.required, Validators.maxLength(255)]],
			group: [this.incidentCode.group, [Validators.required, Validators.maxLength(255)]],
			alias: [this.incidentCode.alias, [Validators.required, Validators.maxLength(255)]],
			isActive: [this.incidentCode.isActive],
		});
		this.subscribeToFormChanges();
	}

	private subscribeToFormChanges(): void {
		this.form.valueChanges.subscribe((value) => {
			Object.keys(value).forEach((key) => {
				if (key in this.incidentCode) {
					this.incidentCode[key] = value[key];
				}
			});
		});
	}

	get controls() {
		return this.form.controls;
	}

	onCancel = () => this.dialogRef.close();

	async onSave() {
		if (this.loading) return;
		this.httpError = '';
		if (this.form.valid) {
			this.loading = true;
			this.service.create(this.incidentCode).subscribe({
				next: (response) => {
					this.created.emit(response);
					this.dialogRef.close();
				},
				error: (errorResponse) => {
					this.httpError = `${errorResponse.status}`;
					this.loading = false;
				},
			});
		}
	}
}
